import { render, staticRenderFns } from "./Sample.vue?vue&type=template&id=3358ef4a&scoped=true&"
import script from "./Sample.vue?vue&type=script&lang=js&"
export * from "./Sample.vue?vue&type=script&lang=js&"
import style0 from "./Sample.vue?vue&type=style&index=0&id=3358ef4a&prod&scoped=true&lang=scss&"
import style1 from "./Sample.vue?vue&type=style&index=1&id=3358ef4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3358ef4a",
  null
  
)

export default component.exports